package com.patronat.top.client.data.reviews

import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.dto.CreateReviewRequest
import com.patronat.top.dto.ReviewListResponse
import com.patronat.top.dto.ReviewResponse
import com.patronat.top.dto.ReviewSummaryResponse

class ClientReviewsRepository(
    private val remoteDataSource: ClientReviewsRemoteDataSource
) {
    suspend fun getVenueReviews(
        venueId: String,
        page: Int,
        pageSize: Int
    ): DomainResult<ReviewListResponse> {
        return remoteDataSource.getVenueReviews(venueId, page, pageSize).asDomainResult { it }
    }

    suspend fun getVenueReviewSummary(venueId: String): DomainResult<ReviewSummaryResponse> {
        return remoteDataSource.getVenueReviewSummary(venueId).asDomainResult { it }
    }

    suspend fun getMyReviews(
        page: Int,
        pageSize: Int
    ): DomainResult<ReviewListResponse> {
        return remoteDataSource.getMyReviews(page, pageSize).asDomainResult { it }
    }

    suspend fun createReview(
        venueId: String,
        request: CreateReviewRequest
    ): DomainResult<ReviewResponse> {
        return remoteDataSource.createReview(venueId, request).asDomainResult { it }
    }

    suspend fun likeReview(reviewId: String): DomainResult<ReviewResponse> {
        return remoteDataSource.likeReview(reviewId).asDomainResult { it }
    }

    suspend fun unlikeReview(reviewId: String): DomainResult<ReviewResponse> {
        return remoteDataSource.unlikeReview(reviewId).asDomainResult { it }
    }
}
